module.exports = __webpack_public_path__ + "img/bess_item-v2_38x38.eb7aec8c.svg";